/**
 * Returns f(x) iff `x` is not null or undefined.
 *
 * @param f - function
 * @param x - value
 */
export const ifDef = (f, x) => x != null ? f(x) : undefined;
